(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Hover behavior for desktop dropdown menus
  function initHoverMenus() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
      const details = menu.querySelector('details');
      if (!details) return;

      let leaveTimeout;

      menu.addEventListener('mouseenter', () => {
        clearTimeout(leaveTimeout);
        details.setAttribute('open', '');
      });

      menu.addEventListener('mouseleave', () => {
        leaveTimeout = setTimeout(() => details.removeAttribute('open'), 350);
      });
    });

    // Same linger delay for language/country localization dropdowns
    document.querySelectorAll('.desktop-localization-wrapper localization-form').forEach((locForm) => {
      const panel = locForm.querySelector('.disclosure__list-wrapper');
      if (!panel) return;

      let leaveTimeout;

      locForm.addEventListener('mouseenter', () => {
        clearTimeout(leaveTimeout);
        if (panel.hasAttribute('hidden')) {
          locForm.openSelector();
        }
      });

      locForm.addEventListener('mouseleave', () => {
        leaveTimeout = setTimeout(() => {
          if (!panel.hasAttribute('hidden')) {
            locForm.hidePanel();
          }
        }, 350);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHoverMenus);
  } else {
    initHoverMenus();
  }

  // ── Drawer accordion patch ──────────────────────────────────────────────
  // Intercepts nested summary clicks in capture phase (before Dawn's bubble-
  // phase onSummaryClick) so Dawn's slide-panel logic never runs.
  function initDrawerAccordion() {
    document.querySelectorAll('header-drawer').forEach(function (drawer) {
      drawer.querySelectorAll('.menu-drawer__menu details > summary').forEach(function (summary) {
        summary.addEventListener(
          'click',
          function (event) {
            event.preventDefault();
            event.stopImmediatePropagation();

            var details = summary.parentElement;
            var submenu = details.querySelector(':scope > .menu-drawer__submenu');
            var isOpen = details.hasAttribute('open');

            if (!isOpen) {
              // Close open siblings instantly (no animation needed for siblings)
              var list = details.parentElement && details.parentElement.parentElement;
              if (list) {
                list.querySelectorAll(':scope > li > details[open]').forEach(function (sib) {
                  var sibSub = sib.querySelector(':scope > .menu-drawer__submenu');
                  if (sibSub) sibSub.classList.remove('submenu-expanded');
                  sib.removeAttribute('open');
                });
              }

              // 1. Set [open] so the submenu div enters the layout at 0fr
              details.setAttribute('open', '');
              if (submenu) {
                // 2. Force a synchronous reflow — commits the 0fr state before the next paint
                submenu.getBoundingClientRect();
                // 3. Add the class that drives 0fr → 1fr; browser now sees a real delta → transition fires
                submenu.classList.add('submenu-expanded');
              }
            } else {
              if (submenu) {
                // Animate 1fr → 0fr, then remove [open] only after the transition completes
                // so the content stays visible during the close animation.
                submenu.classList.remove('submenu-expanded');
                submenu.addEventListener('transitionend', function onEnd(e) {
                  if (e.propertyName !== 'grid-template-rows') return;
                  submenu.removeEventListener('transitionend', onEnd);
                  details.removeAttribute('open');
                });
              } else {
                details.removeAttribute('open');
              }
            }
          },
          true
        );
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerAccordion);
  } else {
    initDrawerAccordion();
  }

  } catch(e) { console.error(e); }
})();
})();
